import React from 'react';
import { toast } from 'react-toastify';

import errorIcon from './icon/error.svg';
import successIcon from './icon/success.svg';

import styles from './toast.css';

const iconMap = {
  error: errorIcon,
  success: successIcon,
};

const showToast = (type, content, props?) => {
  const icon = iconMap[type];
  const render = (
    <div className={styles.container}>
      <img src={icon} alt="" />
      <div className={styles.text}>{content}</div>
    </div>
  );
  return toast[type](render, props);
};

export default showToast;
